<script setup>

    import { onBeforeMount, onMounted } from "vue";
    import setTooltip from "../assets/js/tooltip";
    import router from "../router";
    import cookie from '../assets/js/cookies.js';
    import validSession from "../assets/js/valid-session.js";
    import { useStore } from "vuex";
    import axios from "axios";
    import { useRoute } from "vue-router";
    import SkeletonLoad from "../components/SkeletonLoad.vue";

    import { computed } from "vue";

    const store = useStore();

    const darkMode = computed(() => store.state.darkMode);

    const route = useRoute();

    onBeforeMount(() => {

        validSession.isLogged();

        store.state.card_load = true;

        store.state.validation = {
            nameHasError: false,
            nameMessageError: '',
            accountHasError: false,
            accountMessageError: '',
        };

        store.state.card = {
            icon: 'https://assets.agive.com.br/financas/cartoes/credit-card-logo.png',
            name: '',
            limit: 0,
            close_day: 1,
            due_day: 1,
            account: "",
            id: ''
        };

        store.state.card_details = {
            icon: '',
            name: '',
            limit: 0,
            limit_used: 0,
            close_day: 1,
            due_day: 1,
            account: "",
            id: '',
            fixeds: 0
        };

        store.state.icons = [];
        store.state.accounts = [];
        store.state.cards = [];
        store.state.invoices = [];
        store.state.qtdInvoices = 0;
        store.state.loadingCards = true;
        store.state.savingCard = false;
        store.state.editBalance = false;

        store.state.selectedYear = new Date().getFullYear();

        store.state.card_id = route.params.id ? route.params.id : 0;

        getCard(store.state.card_id);
    
    })

    onMounted(() => {
        setTooltip();

        let session = cookie.get('user_agive_session');

        if(session == null){
            router.push({name: 'Login'});
        }

    });

    const getInvoices = async (card, year) => {

        axios.get('invoices?card='+card+'&year='+year)
        .then(res => {
            
            if(res.status == 200){

                store.state.invoices = res.data.data;
                store.state.card_details.limit_used = parseFloat(store.state.card_details.limit) - (parseFloat(res.data.sum[0].current_amount) - parseFloat(store.state.card_details.fixeds ? store.state.card_details.fixeds : 0));
                
                store.state.card_load = false;

            }
            
        })
        .catch(err => {
            console.error(err); 
        })

    }

    const getCard = async(id) => {

        axios.get('credit-cards/show/'+id)
        .then(res => {
            
            if(res.status == 200){

                store.state.card_details = {
                    icon: res.data.icon,
                    name: res.data.name,
                    limit: res.data.limit,
                    close_day: res.data.close_day,
                    due_day: res.data.due_day,
                    id: res.data.id,
                    fixeds: res.data.future_fixed[0].amount
                };

                getInvoices(res.data.id, store.state.selectedYear);

            }
            
        })
        .catch(err => {
            console.error(err); 
        })

    }

    function formatMoney(v) {
        let total = parseFloat(v);

        return total.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            });
    }

    const getMonthString = (full_date) =>{

        let date = new Date(full_date + 'T01:00:00');
        let month = date.toLocaleString('default', { month: 'long' });

        return month.charAt(0).toUpperCase() + month.slice(1);

    }

    const slideYear = (card, direction) => {

        store.state.card_load = true;

        if(direction == 'prev'){

            let prev_year = store.state.selectedYear - 1;
            
            store.state.selectedYear = prev_year;

            getInvoices(card, store.state.selectedYear);

        }
        else if(direction == 'next'){

            let next_year = store.state.selectedYear + 1;

            store.state.selectedYear = next_year;

            getInvoices(card, store.state.selectedYear);

        }

    }

    const valid_status = (status, type) => {

        if(status == 'Open'){

            if(type == 'class'){
                return 'secondary';
            }
            else if(type == 'title'){
                return 'Em aberto';
            }

        }
        else if(status == 'Closed'){

            if(type == 'class'){
                return 'warning';
            }
            else if(type == 'title'){
                return 'Fechada';
            }

        }
        else if(status == 'Paid'){

            if(type == 'class'){
                return 'success';
            }
            else if(type == 'title'){
                return 'Paga';
            }
            
        }
        else if(status == 'Late'){

            if(type == 'class'){
                return 'error';
            }else if(type == 'title'){
                return 'Em Atraso';
            }          
        }
        else if(status == 'Current'){

            if(type == 'class'){
                return 'info';
            }else if(type == 'title'){
                return 'Atual';
            }          
        }

    }

    const open_invoice = (invoice) => {
        router.push('/fatura/'+invoice);
    }

</script>

<template>
    <div class="py-4 container-fluid card-details-page">
        <div class="row">
            <div class="col-12">

                <div class="card card-details-shell border-0">
                    <div class="card-header card-details-header border-0">
                        <div class="card-details-top">
                            <div class="card-details-brand">
                                <div class="card-details-brand-icon">
                                    <SkeletonLoad
                                        :width='"64px"'
                                        :height="'64px'"
                                        :class="'rounded-5'"
                                        v-if="store.state.card_load"
                                    />
                                    <img v-else :src="store.state.card_details.icon" alt="" class="rounded-5">
                                </div>

                                <div class="card-details-brand-copy">
                                    <span class="card-details-eyebrow">Cartão de crédito</span>
                                    <SkeletonLoad
                                        :width='"180px"'
                                        :height="'34px'"
                                        v-if="store.state.card_load"
                                    />
                                    <h2 v-else class="mb-0">{{ store.state.card_details.name }}</h2>
                                </div>
                            </div>

                            <div class="card-details-year-nav">
                                <button type="button" class="year-nav-btn" @click="slideYear(store.state.card_details.id, 'prev')">
                                    <i class="fal fa-chevron-left"></i>
                                </button>
                                <span>{{ store.state.selectedYear }}</span>
                                <button type="button" class="year-nav-btn" @click="slideYear(store.state.card_details.id, 'next')">
                                    <i class="fal fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body card-details-body">
                        <div class="card-details-summary-grid">
                            <div class="summary-card">
                                <span>Limite</span>
                                <SkeletonLoad
                                    :width='"110px"'
                                    :height="'24px'"
                                    v-if="store.state.card_load"
                                />
                                <strong v-else>{{ formatMoney(store.state.card_details.limit) }}</strong>
                            </div>

                            <div class="summary-card">
                                <span>Disponível para uso</span>
                                <SkeletonLoad
                                    :width='"110px"'
                                    :height="'24px'"
                                    v-if="store.state.card_load"
                                />
                                <strong v-else>{{ formatMoney(store.state.card_details.limit_used) }}</strong>
                            </div>

                            <div class="summary-card">
                                <span>Fechamento</span>
                                <SkeletonLoad
                                    :width='"90px"'
                                    :height="'24px'"
                                    v-if="store.state.card_load"
                                />
                                <strong v-else>Dia {{ store.state.card_details.close_day }}</strong>
                            </div>

                            <div class="summary-card">
                                <span>Vencimento</span>
                                <SkeletonLoad
                                    :width='"90px"'
                                    :height="'24px'"
                                    v-if="store.state.card_load"
                                />
                                <strong v-else>Dia {{ store.state.card_details.due_day }}</strong>
                            </div>
                        </div>

                        <div class="card-details-table-shell">
                            <div class="card-details-table-header">
                                <SkeletonLoad
                                    :width='"90px"'
                                    :height="'20px'"
                                    v-if="store.state.card_load"
                                />
                                <h6 v-else class="mb-0">{{store.state.invoices.length}} Faturas</h6>
                            </div>

                            <div class="table-responsive card-details-table-wrap">
                                <table class="table align-items-center mb-0 card-details-table">
                                    <thead>
                                        <tr class="text-center">
                                            <th>Mês</th>
                                            <th>Situação</th>
                                            <th>Valor da fatura</th>
                                            <th>Valor pago</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="store.state.card_load" class="text-center">
                                        <tr>
                                            <td><SkeletonLoad :width='"90px"' :height="'20px'" :class="'mx-auto'" /></td>
                                            <td><SkeletonLoad :width='"90px"' :height="'20px'" :class="'mx-auto'" /></td>
                                            <td><SkeletonLoad :width='"90px"' :height="'20px'" :class="'mx-auto'" /></td>
                                            <td><SkeletonLoad :width='"90px"' :height="'20px'" :class="'mx-auto'" /></td>
                                            <td></td>
                                        </tr>
                                    </tbody>

                                    <tbody v-else class="text-center">
                                        <tr
                                            v-for="(invoice, index) in store.state.invoices"
                                            :key="index"
                                            :class="{
                                                'text-white': darkMode,
                                                'text-dark': !darkMode
                                            }"
                                        >
                                            <td>
                                                <h6 class="mb-0 text-sm">{{ getMonthString(invoice.due_date) }}</h6>
                                            </td>
                                            <td>
                                                <span
                                                    class="badge badge-sm"
                                                    :class="'bg-gradient-' + valid_status(invoice.status, 'class')"
                                                >
                                                    {{ valid_status(invoice.status, 'title') }}
                                                </span>
                                            </td>
                                            <td class="align-middle text-center text-sm">
                                                <span class="text-xs font-weight-bold">
                                                    {{ formatMoney((parseFloat(invoice.current_amount) + parseFloat(invoice.before_amount))) }}
                                                </span>
                                            </td>
                                            <td class="align-middle text-center">
                                                <span class="text-xs font-weight-bold">
                                                    {{ formatMoney(invoice.payed_amount) }}
                                                </span>
                                            </td>

                                            <td class="align-middle">
                                                <a v-if="invoice.current_amount > 0" @click="payTrasaction(transaction.id, transaction.status)" class="me-3 cursor-pointer">
                                                    <i
                                                        class="fa-thumbs-up row-transactions-icons-actions"
                                                        v-bind:class="{
                                                            'fal text-black-50': invoice.status != 'Paid' && !darkMode,
                                                            'fal text-white-50': invoice.status != 'Paid' && darkMode,
                                                            'fas text-success' : invoice.status == 'Paid'
                                                        }"
                                                        v-tooltip="{
                                                            content: invoice.status != 'Paid' ? 'Pagar' : 'Pago',
                                                            distance: 15
                                                        }"
                                                    >
                                                    </i>
                                                </a>
                                                <a @click="open_invoice(invoice.id)" class="me-3 cursor-pointer">
                                                    <i
                                                        class="fal fa-file-invoice row-transactions-icons-actions"
                                                        v-bind:class="{
                                                            'text-black-50': !darkMode,
                                                            'text-white-50': darkMode,
                                                        }"
                                                        v-tooltip="{
                                                            content: 'Ver fatura',
                                                            distance: 15
                                                        }"
                                                    >
                                                    </i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.card-details-shell{
    overflow:hidden;
    border-radius:24px !important;
    background:#f6f3eb;
    box-shadow:0 12px 40px rgba(24,39,75,.08);
}

.card-details-header{
    padding:1.2rem 1.25rem !important;
    background:linear-gradient(135deg,#1f4876 0%, #224a78 55%, #1f436d 100%) !important;
}

.card-details-top{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:18px;
}

.card-details-brand{
    display:flex;
    align-items:center;
    gap:16px;
    min-width:0;
}

.card-details-brand-icon{
    width:72px;
    height:72px;
    min-width:72px;
    border-radius:20px;
    background:rgba(255,255,255,.1);
    display:flex;
    align-items:center;
    justify-content:center;
    box-shadow:inset 0 1px 0 rgba(255,255,255,.08);
}

.card-details-brand-icon img{
    width:50px;
    height:50px;
    object-fit:contain;
}

.card-details-brand-copy{
    min-width:0;
}

.card-details-eyebrow{
    display:inline-block;
    margin-bottom:8px;
    font-size:.92rem;
    color:rgba(255,255,255,.78);
}

.card-details-brand-copy h2{
    margin:0;
    color:#ffffff;
    font-size:1.9rem;
    font-weight:800;
    line-height:1.1;
}

.card-details-year-nav{
    display:flex;
    align-items:center;
    justify-content:center;
    gap:18px;
    min-width:220px;
    color:#ffffff;
    font-weight:700;
    font-size:1.5rem;
}

.year-nav-btn{
    width:40px;
    height:40px;
    border:none;
    border-radius:12px;
    background:rgba(255,255,255,.08);
    color:rgba(255,255,255,.95);
    display:inline-flex;
    align-items:center;
    justify-content:center;
    transition:all .2s ease;
}

.year-nav-btn:hover{
    transform:translateY(-1px);
    background:rgba(255,255,255,.14);
}

.card-details-body{
    padding:1.4rem !important;
    background:#f7f4ee;
}

.card-details-summary-grid{
    display:grid;
    grid-template-columns:repeat(4, minmax(0, 1fr));
    gap:14px;
    margin-bottom:1.25rem;
}

.summary-card{
    background:rgba(255,255,255,.82);
    border:1px solid rgba(213,205,193,.5);
    border-radius:20px;
    padding:1rem 1rem .9rem;
    text-align:center;
    box-shadow:inset 0 1px 0 rgba(255,255,255,.45);
}

.summary-card span{
    display:block;
    color:#6b7c93;
    font-size:.92rem;
    margin-bottom:.35rem;
}

.summary-card strong{
    color:#213E60;
    font-size:1.55rem;
    font-weight:800;
    line-height:1.2;
}

.card-details-table-shell{
    border-radius:24px;
    overflow:hidden;
    background:rgba(255,255,255,.62);
    border:1px solid rgba(213,205,193,.5);
    box-shadow:inset 0 1px 0 rgba(255,255,255,.45);
}

.card-details-table-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:1rem 1.25rem;
    background:linear-gradient(135deg,#1f4876 0%, #224a78 55%, #1f436d 100%);
}

.card-details-table-header h6{
    color:#ffffff;
    font-size:1.05rem;
    font-weight:800;
}

.card-details-table-wrap{
    padding:0;
}

.card-details-table{
    margin:0 !important;
    background:transparent;
}

.card-details-table thead th{
    border-bottom:1px solid #dbe2ea !important;
    color:#6b7c93 !important;
    font-size:.72rem !important;
    text-transform:uppercase !important;
    font-weight:800 !important;
    letter-spacing:.02em;
    padding:1rem .75rem !important;
    background:rgba(255,255,255,.5);
}

.card-details-table tbody td{
    padding:1rem .75rem !important;
    border-bottom:1px solid #e6eaf0 !important;
    vertical-align:middle !important;
}

.card-details-table tbody tr:last-child td{
    border-bottom:none !important;
}

@media (max-width: 991.98px){
    .card-details-top{
        flex-direction:column;
        align-items:stretch;
    }

    .card-details-year-nav{
        min-width:0;
        width:100%;
    }

    .card-details-summary-grid{
        grid-template-columns:repeat(2, minmax(0,1fr));
    }
}

@media (max-width: 575.98px){
    .card-details-header{
        padding:1rem !important;
    }

    .card-details-brand{
        align-items:flex-start;
    }

    .card-details-brand-icon{
        width:60px;
        height:60px;
        min-width:60px;
        border-radius:16px;
    }

    .card-details-brand-icon img{
        width:42px;
        height:42px;
    }

    .card-details-brand-copy h2{
        font-size:1.45rem;
    }

    .card-details-year-nav{
        font-size:1.15rem;
        gap:10px;
    }

    .year-nav-btn{
        width:36px;
        height:36px;
    }

    .card-details-body{
        padding:1rem !important;
    }

    .card-details-summary-grid{
        grid-template-columns:1fr;
        gap:10px;
    }

    .summary-card strong{
        font-size:1.25rem;
    }

    .card-details-table-shell{
        border-radius:18px;
    }

    .card-details-table-header{
        padding:.9rem 1rem;
    }
}
</style>
